/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as AppRouteImport } from './routes/_app'
import { Route as AppIndexRouteImport } from './routes/_app.index'
import { Route as AppGGardenTokenRouteRouteImport } from './routes/_app.g.$gardenToken/route'
import { Route as AppGGardenTokenIndexRouteImport } from './routes/_app.g.$gardenToken/index'
import { Route as AppGGardenTokenJournalRouteImport } from './routes/_app.g.$gardenToken/journal'
import { Route as AppGGardenTokenLocationsRouteImport } from './routes/_app.g.$gardenToken/locations'
import { Route as AppGGardenTokenPlantsRouteImport } from './routes/_app.g.$gardenToken/plants'

const AppRoute = AppRouteImport.update({
  id: '/_app',
  getParentRoute: () => rootRouteImport,
} as any)
const AppIndexRoute = AppIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppRoute,
} as any)
const AppGGardenTokenRouteRoute = AppGGardenTokenRouteRouteImport.update({
  id: '/g/$gardenToken',
  path: '/g/$gardenToken',
  getParentRoute: () => AppRoute,
} as any)
const AppGGardenTokenIndexRoute = AppGGardenTokenIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppGGardenTokenRouteRoute,
} as any)
const AppGGardenTokenJournalRoute = AppGGardenTokenJournalRouteImport.update({
  id: '/journal',
  path: '/journal',
  getParentRoute: () => AppGGardenTokenRouteRoute,
} as any)
const AppGGardenTokenLocationsRoute =
  AppGGardenTokenLocationsRouteImport.update({
    id: '/locations',
    path: '/locations',
    getParentRoute: () => AppGGardenTokenRouteRoute,
  } as any)
const AppGGardenTokenPlantsRoute = AppGGardenTokenPlantsRouteImport.update({
  id: '/plants',
  path: '/plants',
  getParentRoute: () => AppGGardenTokenRouteRoute,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof AppIndexRoute
  '/g/$gardenToken': typeof AppGGardenTokenRouteRouteWithChildren
  '/g/$gardenToken/journal': typeof AppGGardenTokenJournalRoute
  '/g/$gardenToken/locations': typeof AppGGardenTokenLocationsRoute
  '/g/$gardenToken/plants': typeof AppGGardenTokenPlantsRoute
  '/g/$gardenToken/': typeof AppGGardenTokenIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof AppIndexRoute
  '/g/$gardenToken/journal': typeof AppGGardenTokenJournalRoute
  '/g/$gardenToken/locations': typeof AppGGardenTokenLocationsRoute
  '/g/$gardenToken/plants': typeof AppGGardenTokenPlantsRoute
  '/g/$gardenToken': typeof AppGGardenTokenIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/_app': typeof AppRouteWithChildren
  '/_app/': typeof AppIndexRoute
  '/_app/g/$gardenToken': typeof AppGGardenTokenRouteRouteWithChildren
  '/_app/g/$gardenToken/journal': typeof AppGGardenTokenJournalRoute
  '/_app/g/$gardenToken/locations': typeof AppGGardenTokenLocationsRoute
  '/_app/g/$gardenToken/plants': typeof AppGGardenTokenPlantsRoute
  '/_app/g/$gardenToken/': typeof AppGGardenTokenIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/g/$gardenToken'
    | '/g/$gardenToken/journal'
    | '/g/$gardenToken/locations'
    | '/g/$gardenToken/plants'
    | '/g/$gardenToken/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/g/$gardenToken/journal'
    | '/g/$gardenToken/locations'
    | '/g/$gardenToken/plants'
    | '/g/$gardenToken'
  id:
    | '__root__'
    | '/_app'
    | '/_app/'
    | '/_app/g/$gardenToken'
    | '/_app/g/$gardenToken/journal'
    | '/_app/g/$gardenToken/locations'
    | '/_app/g/$gardenToken/plants'
    | '/_app/g/$gardenToken/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  AppRoute: typeof AppRouteWithChildren
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/_app': {
      id: '/_app'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AppRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_app/': {
      id: '/_app/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof AppIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/g/$gardenToken': {
      id: '/_app/g/$gardenToken'
      path: '/g/$gardenToken'
      fullPath: '/g/$gardenToken'
      preLoaderRoute: typeof AppGGardenTokenRouteRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/g/$gardenToken/': {
      id: '/_app/g/$gardenToken/'
      path: '/'
      fullPath: '/g/$gardenToken/'
      preLoaderRoute: typeof AppGGardenTokenIndexRouteImport
      parentRoute: typeof AppGGardenTokenRouteRoute
    }
    '/_app/g/$gardenToken/journal': {
      id: '/_app/g/$gardenToken/journal'
      path: '/journal'
      fullPath: '/g/$gardenToken/journal'
      preLoaderRoute: typeof AppGGardenTokenJournalRouteImport
      parentRoute: typeof AppGGardenTokenRouteRoute
    }
    '/_app/g/$gardenToken/locations': {
      id: '/_app/g/$gardenToken/locations'
      path: '/locations'
      fullPath: '/g/$gardenToken/locations'
      preLoaderRoute: typeof AppGGardenTokenLocationsRouteImport
      parentRoute: typeof AppGGardenTokenRouteRoute
    }
    '/_app/g/$gardenToken/plants': {
      id: '/_app/g/$gardenToken/plants'
      path: '/plants'
      fullPath: '/g/$gardenToken/plants'
      preLoaderRoute: typeof AppGGardenTokenPlantsRouteImport
      parentRoute: typeof AppGGardenTokenRouteRoute
    }
  }
}

interface AppGGardenTokenRouteRouteChildren {
  AppGGardenTokenJournalRoute: typeof AppGGardenTokenJournalRoute
  AppGGardenTokenLocationsRoute: typeof AppGGardenTokenLocationsRoute
  AppGGardenTokenPlantsRoute: typeof AppGGardenTokenPlantsRoute
  AppGGardenTokenIndexRoute: typeof AppGGardenTokenIndexRoute
}

const AppGGardenTokenRouteRouteChildren: AppGGardenTokenRouteRouteChildren = {
  AppGGardenTokenJournalRoute: AppGGardenTokenJournalRoute,
  AppGGardenTokenLocationsRoute: AppGGardenTokenLocationsRoute,
  AppGGardenTokenPlantsRoute: AppGGardenTokenPlantsRoute,
  AppGGardenTokenIndexRoute: AppGGardenTokenIndexRoute,
}

const AppGGardenTokenRouteRouteWithChildren =
  AppGGardenTokenRouteRoute._addFileChildren(AppGGardenTokenRouteRouteChildren)

interface AppRouteChildren {
  AppIndexRoute: typeof AppIndexRoute
  AppGGardenTokenRouteRoute: typeof AppGGardenTokenRouteRouteWithChildren
}

const AppRouteChildren: AppRouteChildren = {
  AppIndexRoute: AppIndexRoute,
  AppGGardenTokenRouteRoute: AppGGardenTokenRouteRouteWithChildren,
}

const AppRouteWithChildren = AppRoute._addFileChildren(AppRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  AppRoute: AppRouteWithChildren,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
